/* eslint-disable react-hooks/exhaustive-deps */
import React, { Suspense, useEffect } from "react";
import { matchPath } from "react-router";
import { Route, Switch, Redirect, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";

import {
  fetchAppSettingsStart,
  checkAuthStart,
  showLoginPage,
  logoutUser,
  fetchAccountDetailsStart,
  fetchCCDetailsStart
} from "store/actions";
import Layout from "App/common/hoc/Layout";
import {
  NAV_LIST,
  AUTH_LIST,
  EXCEPTION_LIST,
  NAV_LIST_SUB,
  NAV_LIST_360,
  INDEPENDENT_LIST,
  ACCOUNT_SETTINGS_TABS
} from "./componentsConfig";
import { disableEnableStyleSheets, addLinkTagContent } from "utils";
import { STYLE_SHEETS } from "consts";
import Loader from "App/common/ui/Loader";
import FullPageLoader from "App/common/ui/FullPageLoader";
import { HELPERS } from "../consts";
import { forbidExtraProps } from "utils";

function App(props) {
  let currentRoute = props.location.pathname;
  const teamPlan =
    props.plan &&
    ("" + props.plan.id)[0] === "2" &&
    props.plan &&
    props.plan.id > 199;
  const appRoutes =
    props.origin === "360" ||
    props.origin === "ibackup" ||
    props.origin === "idrive"
      ? NAV_LIST_360.map(page => page.path)
      : props.ecommerceFlag === "S" || !teamPlan
      ? NAV_LIST_SUB.map(page => page.path)
      : NAV_LIST.map(page => page.path);
  const AUTH_LIST_SELECT =
    process.env.REACT_APP_NAME === "ibackup"
      ? AUTH_LIST.filter(list => list.name === "Ibackup")
      : AUTH_LIST;
  const EXCEPTION_LIST_SELECT =
    process.env.REACT_APP_NAME === "ibackup"
      ? EXCEPTION_LIST.filter(
          list => list.name === "Ibackup" || list.name === "LogoutIbackup"
        )
      : EXCEPTION_LIST;
  const authRoutes = AUTH_LIST_SELECT.map(page => page.path);
  const exceptionRoutes = EXCEPTION_LIST.map(page => page.path);
  const independentRoutes = INDEPENDENT_LIST.map(page => page.path);
  const currentRouteForExcep = [
    currentRoute.split("/")[0],
    currentRoute.split("/")[1],
    currentRoute.split("/")[2]
  ].join("/");

  useEffect(() => {
    if (
      !localStorage.getItem("rememberMe") ||
      (!JSON.parse(localStorage.getItem("rememberMe")).rememberMe &&
        new Date(
          new Date(
            JSON.parse(localStorage.getItem("rememberMe")).loggedInTime
          ).getTime() +
            60 * 60 * 24 * 1000
        ).getTime() < new Date().getTime())
    ) {
      props.logoutUser(false);
    } else {
      if (localStorage.getItem("token")) props.checkAuthStart();
      else props.showLoginPage();
    }
    window.addEventListener("storage", e => {
      if (e.key === "origin" && e.oldValue && !e.newValue) {
        if (e.oldValue === "360") {
          setTimeout(() => {
            localStorage.getItem("origin") === "360"
              ? window.location.reload()
              : props.logoutUser(false, "360");
          }, 2000);
        } else if (e.oldValue === "ibackup") {
          setTimeout(() => {
            localStorage.getItem("origin") === "ibackup"
              ? window.location.reload()
              : props.logoutUser(false, "ibackup");
          }, 2000);
        } else if (e.oldValue === "idrive") {
          setTimeout(() => {
            localStorage.getItem("origin") === "idrive"
              ? window.location.reload()
              : props.logoutUser(false, "idrive");
          }, 2000);
        } else props.logoutUser();
        // setTimeout(()=>window.location.reload(),2000);
      }
    });
  }, []);

  useEffect(() => {
    if (props.auth.isAuthenticated) {
      if (!Object.keys(props.enums).length) props.fetchAppSettingsStart();
      props.fetchAccountDetailsStart();
      if (
        props.plan &&
        props.plan.planType === "Paid" &&
        props.ecommerceFlag === "Y"
      ) {
        props.fetchCCDetailsStart();
      }
    }
  }, [props.auth.isAuthenticated, props.plan, props.ecommerceFlag]);

  // Change Title dynamically
  useEffect(() => {
    const currentRouteDetails = [
      ...AUTH_LIST,
      ...NAV_LIST,
      ...Object.values(ACCOUNT_SETTINGS_TABS)
    ].find(page => page.path === props.location.pathname);
    if (currentRouteDetails)
      document.title =
        process.env.REACT_APP_WEBSITE_NAME.replace("&reg;", "\xAE") +
        " - " +
        currentRouteDetails.name;
  }, [currentRoute]);

  if (!currentRoute.match(/^[/]mirror[/]signup[/][A-Za-z0-9]+/g)) {
    disableEnableStyleSheets(
      [
        STYLE_SHEETS.styles,
        STYLE_SHEETS.responsiveStyles,
        STYLE_SHEETS.restoreCSS,
        STYLE_SHEETS.subUserCSS,
        STYLE_SHEETS.switch,
        STYLE_SHEETS.backupPlanCSS,
        STYLE_SHEETS.pdfTemplateCSS,
        STYLE_SHEETS.virtualization_dashboard
      ],
      [STYLE_SHEETS.login]
    );
  }
  useEffect(() => {
    if (
      props.expiryDays < 1 &&
      props.plan &&
      props.plan.planType !== "Paid" &&
      props.ecommerceFlag !== "S" &&
      props.ecommerceFlag !== "O" &&
      props.ecommerceFlag !== "Y" &&
      currentRoute !== "/mirror/account/planOptions"
    ) {
      props.history.push("/mirror/account/planOptions");
    } else if (props.applyPendingChargesFlag) {
      props.history.push("/mirror/account/planOptions");
    }
  }, [
    props.expiryDays,
    props.plan,
    props.ecommerceFlag,
    props.applyPendingChargesFlag
  ]);

  let pages = null;
  try {
    if (props.auth.loading) pages = <FullPageLoader />;
    else if (props.auth.isAuthenticated) {
      disableEnableStyleSheets(
        [
          STYLE_SHEETS.login,
          STYLE_SHEETS.subUserCSS,
          STYLE_SHEETS.pdfTemplateCSS
        ],
        [
          STYLE_SHEETS.styles,
          STYLE_SHEETS.responsiveStyles,
          STYLE_SHEETS.restoreCSS,
          // STYLE_SHEETS.subUserCSS,
          STYLE_SHEETS.backupPlanCSS,
          STYLE_SHEETS.virtualization_dashboard
        ]
      );
      if (exceptionRoutes.includes(currentRouteForExcep)) {
        disableEnableStyleSheets(
          [
            STYLE_SHEETS.styles,
            STYLE_SHEETS.responsiveStyles,
            STYLE_SHEETS.restoreCSS,
            STYLE_SHEETS.subUserCSS,
            STYLE_SHEETS.switch,
            STYLE_SHEETS.backupPlanCSS,
            STYLE_SHEETS.pdfTemplateCSS,
            STYLE_SHEETS.virtualization_dashboard
          ],
          [STYLE_SHEETS.login]
        );
      } else if (
        authRoutes.includes(currentRoute) ||
        (props.auth.isAuthenticated &&
          !appRoutes.includes(currentRoute) &&
          !independentRoutes.includes(currentRoute))
      )
        currentRoute = "/mirror/dashboard";
      if (
        !exceptionRoutes.includes(currentRouteForExcep) &&
        !currentRoute.match(/^[/]mirror[/]signup[/][A-Za-z0-9]+/g) &&
        independentRoutes.includes(currentRoute)
      ) {
        pages = (
          <Suspense fallback={<Loader />}>
            <Switch>
              {INDEPENDENT_LIST.map(page => (
                <Route
                  key={page.name}
                  path={page.path}
                  component={page.component}
                />
              ))}
              <Redirect to={currentRoute} />
            </Switch>
          </Suspense>
        );
      } else if (
        !exceptionRoutes.includes(currentRouteForExcep) &&
        !currentRoute.match(/^[/]mirror[/]signup[/][A-Za-z0-9]+/g)
      )
        pages = (
          <Layout
            auth={props.auth}
            route={props.location}
            expiryDays={props.expiryDays}
            planType={props.plan && props.plan.planType}
            ccfailureAccount={props.ccfailureAccount}
            noOfClients={Object.keys(props.clientsList).length}
            ecommerceFlag={props.ecommerceFlag}
            origin={props.origin}
            // commonNotify={props.commonNotify}
          >
            <Suspense fallback={""}>
              <Switch>
                {props.origin === "360" ||
                props.origin === "ibackup" ||
                props.origin === "idrive"
                  ? NAV_LIST_360.map(page => (
                      <Route
                        key={page.name}
                        path={page.path}
                        component={page.component}
                      />
                    ))
                  : props.ecommerceFlag === "S" || !teamPlan //if subuser or free account
                  ? NAV_LIST_SUB.map(page => (
                      <Route
                        key={page.name}
                        path={page.path}
                        component={page.component}
                      />
                    ))
                  : NAV_LIST.map(page => (
                      <Route
                        key={page.name}
                        path={page.path}
                        component={page.component}
                      />
                    ))}
                <Redirect to={currentRoute} />
              </Switch>
            </Suspense>
          </Layout>
        );
      else
        pages = (
          <Suspense fallback={<Loader />}>
            <Switch>
              {EXCEPTION_LIST_SELECT.map(page => (
                <Route
                  key={page.name}
                  path={page.path}
                  render={() =>
                    React.createElement(page.component, {
                      ...{ logout: true, location: props.location }
                    })
                  }
                />
              ))}
              <Redirect
                to={
                  process.env.REACT_APP_NAME === "ibackup"
                    ? "/mirror/dashboard"
                    : currentRoute
                }
              />
            </Switch>
          </Suspense>
        );
    } else {
      if (currentRoute === "/" || !authRoutes.includes(currentRoute)) {
        if (
          process.env.REACT_APP_NAME === "ibackup" &&
          !currentRoute.includes("/mirror/validateIbackup")
        )
          window.location =
            "https://www.ibackup.com/newibackup/login/loginForm";
        else currentRoute = "/mirror/login";
      }

      pages = (
        <Suspense fallback={<Loader />}>
          <Switch>
            {AUTH_LIST_SELECT.map(page => (
              <Route
                key={page.name}
                path={page.path}
                component={page.component}
              />
            ))}
            <Redirect to={currentRoute} />
          </Switch>
        </Suspense>
      );
    }
  } catch (e) {
    console.log(e);
  }

  if (currentRouteForExcep === "/mirror/activateSubUser") {
    disableEnableStyleSheets(
      [
        STYLE_SHEETS.restoreCSS,
        STYLE_SHEETS.login,
        STYLE_SHEETS.responsiveStyles,
        STYLE_SHEETS.backupPlanCSS,
        STYLE_SHEETS.pdfTemplateCSS,
        STYLE_SHEETS.virtualizationCSS,
        STYLE_SHEETS.virtualization_dashboard
      ],
      [STYLE_SHEETS.styles, STYLE_SHEETS.subUserCSS]
    );
  } else if (currentRoute.match(/^[/]mirror[/]signup[/][A-Za-z0-9]+/g)) {
    disableEnableStyleSheets(
      [
        STYLE_SHEETS.restoreCSS,
        STYLE_SHEETS.login,
        STYLE_SHEETS.responsiveStyles,
        STYLE_SHEETS.styles,
        STYLE_SHEETS.subUserCSS,
        STYLE_SHEETS.backupPlanCSS,
        STYLE_SHEETS.pdfTemplateCSS,
        STYLE_SHEETS.virtualizationCSS,
        STYLE_SHEETS.virtualization_dashboard
      ],
      [STYLE_SHEETS.switch]
    );
  } else if (currentRoute.match(/^[/]mirror[/]backupPlan/g)) {
    disableEnableStyleSheets(
      [
        STYLE_SHEETS.login,
        STYLE_SHEETS.subUserCSS,
        STYLE_SHEETS.pdfTemplateCSS,
        STYLE_SHEETS.virtualizationCSS,
        STYLE_SHEETS.restoreCSS,
        STYLE_SHEETS.virtualization_dashboard
      ],
      [
        STYLE_SHEETS.styles,
        STYLE_SHEETS.responsiveStyles,
        STYLE_SHEETS.backupPlanCSS
      ]
    );
  } else if (currentRoute.match(/^[/]mirror[/]users/g)) {
    disableEnableStyleSheets(
      [
        STYLE_SHEETS.login,
        STYLE_SHEETS.pdfTemplateCSS,
        STYLE_SHEETS.virtualizationCSS,
        STYLE_SHEETS.restoreCSS,
        STYLE_SHEETS.virtualization_dashboard
      ],
      [
        STYLE_SHEETS.styles,
        STYLE_SHEETS.subUserCSS,
        STYLE_SHEETS.responsiveStyles,
        STYLE_SHEETS.backupPlanCSS
      ]
    );
  } else if (currentRoute.match(/^[/]mirror[/]virtualization/g)) {
    disableEnableStyleSheets(
      [
        STYLE_SHEETS.login,
        STYLE_SHEETS.subUserCSS,
        STYLE_SHEETS.restoreCSS,
        STYLE_SHEETS.pdfTemplateCSS,
        STYLE_SHEETS.virtualization_dashboard
      ],
      [
        STYLE_SHEETS.styles,
        STYLE_SHEETS.responsiveStyles,
        STYLE_SHEETS.virtualizationCSS
      ]
    );
  } else if (currentRoute.match(/^[/]mirror[/]dashboard/g)) {
    disableEnableStyleSheets(
      [
        STYLE_SHEETS.login,
        STYLE_SHEETS.subUserCSS,
        STYLE_SHEETS.pdfTemplateCSS,
        STYLE_SHEETS.virtualizationCSS
      ],
      [
        STYLE_SHEETS.styles,
        STYLE_SHEETS.responsiveStyles,
        STYLE_SHEETS.virtualization_dashboard
      ]
    );
  } else if (currentRoute.match(/^[/]mirror[/]backupPlan/g)) {
    disableEnableStyleSheets(
      [
        STYLE_SHEETS.login,
        STYLE_SHEETS.subUserCSS,
        STYLE_SHEETS.pdfTemplateCSS,
        STYLE_SHEETS.virtualizationCSS,
        STYLE_SHEETS.virtualization_dashboard,
        STYLE_SHEETS.backupPlanCSS
      ],
      [
        STYLE_SHEETS.styles,
        STYLE_SHEETS.responsiveStyles,
        STYLE_SHEETS.restoreCSS
      ]
    );
  } else if (currentRoute.match(/^[/]mirror[/]viconsole/g)) {
    disableEnableStyleSheets(
      [
        STYLE_SHEETS.login,
        STYLE_SHEETS.subUserCSS,
        STYLE_SHEETS.pdfTemplateCSS,
        STYLE_SHEETS.virtualizationCSS,
        STYLE_SHEETS.styles,
        STYLE_SHEETS.responsiveStyles,
        STYLE_SHEETS.restoreCSS,
        STYLE_SHEETS.backupPlanCSS
      ],
      [STYLE_SHEETS.virtualization_dashboard, STYLE_SHEETS.styles]
    );
  }

  addLinkTagContent("canonical", document.location.href);

  return pages;
}

App.propTypes = forbidExtraProps(
  {
    clients: PropTypes.shape({
      loading: PropTypes.bool.isRequired,
      list: PropTypes.object.isRequired
    }).isRequired
  },
  [...HELPERS.withRouter]
);

function mapStateToProps(state) {
  return {
    auth: state.auth,
    enums: state.common.enums,
    expiryDays: state.account.expiryDays,
    clientsList: state.dashboard.clients.list,
    ecommerceFlag: state.account.ecommerceFlag,
    plan: state.account.plan,
    ccfailureAccount: state.account.ccfailureAccount,
    origin: state.account.origin,
    applyPendingChargesFlag: state.account.applyPendingChargesFlag
    // commonNotify: state.common.notification
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      checkAuthStart,
      fetchAppSettingsStart,
      showLoginPage,
      logoutUser,
      fetchAccountDetailsStart,
      fetchCCDetailsStart
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(App));
